/*
 * SPDX-FileCopyrightText: 2025 Zextras <https://www.zextras.com>
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */

import React from 'react';

import { SnackbarManager } from '@zextras/carbonio-design-system';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { LoginCE } from './loginCE';
import { ThemeProvider } from './theme-provider/theme-provider';

export function App(): React.JSX.Element {
	return (
		<ThemeProvider>
			<SnackbarManager>
				<Router>
					<Switch>
						<LoginCE />
					</Switch>
				</Router>
			</SnackbarManager>
		</ThemeProvider>
	);
}
